import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/en-gb";
import { LocalizationProvider as Provider } from "@mui/x-date-pickers/LocalizationProvider";
import type * as React from "react";

export interface LocalizationProviderProps {
  children: React.ReactNode;
}

export function LocalizationProvider({ children }: LocalizationProviderProps): React.JSX.Element {
  return (
    <Provider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
      {children}
    </Provider>
  );
}
